import React from 'react';
import cx from 'classnames';
import './DRMDashboard.scss';
import './DRMDashboardFinal.scss';
import './HomeMock.scss';
import NewOrgEmptyState from './drm/NewOrgEmptyState';
import {
  TodayGroup,
  OutlookGroup,
  AttentionGroup,
  WhereChaserHelpsGroup,
} from './drm/Groups';
import useOrganisation from '../../hooks/useOrganisation';
import useShortCode from '../../hooks/useShortCode';
import useDrmMetricsSyncPoll from '../../hooks/useDrmMetricsSyncPoll';
import { useBottomNotificationContext } from '../../components/BottomNotification/bottomNotificationContext';
import { hasOrganisationSynced } from '../../util/organisation';
import { Integrations, CSVIntegrationTypes } from '../../util/constants';
import useUser from '../../hooks/useUser';
import useDisplayBanner from '../../hooks/useDisplayBanner';

export default function Home() {
  const user = useUser();
  const organisation = useOrganisation();
  const shortCode = useShortCode();
  const isManualCsvOrg =
    organisation?.accountingSoftware === Integrations.CSV &&
    organisation?.accessToken?.type === CSVIntegrationTypes.MANUAL;
  const isNewOrg = !isManualCsvOrg && !hasOrganisationSynced(organisation);
  const notificationShowing = useBottomNotificationContext();
  const showTrialBanner = useDisplayBanner();

  const { isRecalculating } = useDrmMetricsSyncPoll({
    shortCode,
    lastRefreshDate: organisation.lastRefreshDate,
  });

  return (
    <div className="home-mock-main">
      <div className={cx('home-mock-main--inner', 'drm-final-wrapper', notificationShowing && 'has-bottom-notification', showTrialBanner && 'has-trial-banner')}>
        {isNewOrg ? (
          <NewOrgEmptyState />
        ) : (
          <div className="drm-final-grid">
            <TodayGroup
              isRecalculatingMetrics={isRecalculating}
              firstName={user?.profile?.firstName || ''}
              lastName={user?.profile?.lastName || ''}
            />
            <OutlookGroup />
            <AttentionGroup />
            <WhereChaserHelpsGroup />
          </div>
        )}
      </div>
    </div>
  );
}
